import React, { Component } from "react";
import AccountAction from "pages/accounts/_components/AccountAction";
import Dropdown from "pages/_components/Dropdown";
import { bool, shape, string } from "prop-types";

class AccountTransfers extends Component {
    static propTypes = {
        classNames: string,
        account: shape({}).isRequired,
        isDesktop: bool,
    };

    static defaultProps = {
        classNames: undefined,
        isDesktop: false,
    };

    render() {
        const { classNames, account, isDesktop } = this.props;
        const transferActions = [];
        if (account.permissions["transfer.internal"]) {
            transferActions.push(
                <AccountAction
                    key="transfer.internal"
                    labelKey="menu.transfers.internal"
                    to={{ pathname: "/formCustom/transferInternal", search: `?debitAccount=${account.idProduct}` }}
                    className={classNames}
                />,
            );
        }
        if (account.permissions["transfer.thirdParties"]) {
            transferActions.push(
                <AccountAction
                    key="transfer.thirdParties"
                    labelKey="menu.transfers.thirdParties"
                    className={classNames}
                    to={{ pathname: "/formCustom/transferThirdParties", search: `?debitAccount=${account.idProduct}` }}
                />,
            );
        }
        if (account.permissions["transfer.local"]) {
            transferActions.push(
                <AccountAction
                    key="transfer.local"
                    labelKey="menu.transfers.local"
                    className={classNames}
                    to={{ pathname: "/formCustom/transferLocal", search: `?debitAccount=${account.idProduct}` }}
                />,
            );
        }
        if (account.permissions["transfer.foreign"]) {
            transferActions.push(
                <AccountAction
                    key="transfer.foreign"
                    labelKey="menu.transfers.foreign"
                    className={classNames}
                    to={{ pathname: "/formCustom/transferForeign", search: `?debitAccount=${account.idProduct}` }}
                />,
            );
        }

        return isDesktop && transferActions.length > 1 ? (
            <Dropdown key="transfers" label="menu.transfers" buttonClass="btn btn-quiet">
                {transferActions}
            </Dropdown>
        ) : (
            transferActions.map((transferAction) => (
                <li className="navigational-list-item" key={transferAction.key}>
                    {transferAction}
                </li>
            ))
        );
    }
}

export default AccountTransfers;
